<template>
    <div ref="menu" :class="{'navigationslide':true, on: showmenu}">
        <div class="links">
            <ul>
                <li class="menuitem nohalo"><router-link @click.native="handleMenuClick()" to="/" class="nohalo">Home</router-link></li>
                <li class="menuitem nohalo"><router-link @click.native="handleMenuClick()" to="/about" class="nohalo">About</router-link></li>
                <li class="menuitem nohalo"><router-link @click.native="handleMenuClick()" to="/playground" class="nohalo">Playground</router-link></li>
                <li class="menuitem nohalo"><router-link @click.native="handleMenuClick()" to="/images" class="nohalo">Photography</router-link></li>
                <li class="menuitem nohalo"><router-link @click.native="handleMenuClick()" to="/contact" class="nohalo">Contact</router-link></li>
                <li class="menuitem nohalo"><router-link @click.native="handleMenuClick()" to="/imprint" class="nohalo">Imprint</router-link></li>
            </ul>
        </div>
        <div class="smlinks">
            <ul>
                <li class="someicon nohalo">
                  <a aria-label="github" href="https://github.com/thooyork" target="_blank" rel="noreferrer" class="nohalo">
                    <svg-icon name="github" fill="#FFFFFF" hoverfill="#6E5494" size="16"/>
                  </a>
                </li>
                <li class="someicon nohalo">
                  <a aria-label="twitter" href="https://twitter.com/thooyork" target="_blank" rel="noreferrer" class="nohalo">
                    <svg-icon name="twitter" fill="#FFFFFF" hoverfill="#00ACEE" size="16"/>
                  </a>
                </li>
                <li class="someicon nohalo">
                  <a  aria-label="instagram" href="https://www.instagram.com/thomashaaf/" target="_blank" rel="noreferrer" class="nohalo">
                    <svg-icon name="instagram" fill="#FFFFFF" hoverfill="#8A3AB9" size="16"/>
                  </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import {
  gsap, TimelineMax, Power4, TweenMax, Power2, Back,
} from 'gsap/dist/gsap';
/* eslint-enable no-unused-vars */
import helper from '../helper';
import SvgIcon from './SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },
  props: {
    showmenu: {
      required: true,
      type: Boolean,
    },
  },
  updated() {
    const menuWidthPercent = helper.isMobile() ? 100 : 38;
    const menuTL = new TimelineMax();
    if (this.showmenu) {
      menuTL.fromTo(this.$refs.menu, 1, { autoAlpha: 0, right: `-${menuWidthPercent}%` }, { autoAlpha: 1, right: '0%', ease: Power4.easeInOut })
        .staggerFromTo('.menuitem', 1, { autoAlpha: 0, left: '50%' }, { autoAlpha: 1, left: '0%', ease: Power4.easeOut }, 0.05, '-=0.3')
        .staggerFromTo('.someicon', 1, { autoAlpha: 0, top: '15%' }, { autoAlpha: 1, top: '0', ease: Power4.easeOut }, 0.05, '-=1');
    } else {
      menuTL.fromTo(this.$refs.menu, 1, { autoAlpha: 1, right: '0%' }, { autoAlpha: 0, right: `-${menuWidthPercent}%`, ease: Power4.easeInOut });
    }
  },
  methods: {
    handleMenuClick() {
      if (helper.isMobile()) {
        this.$emit('update:menu', false);
      }
    },
  },
};
</script>

<style lang="scss">
 @import '@/assets/scss/app.scss';
.navigationslide{
  flex:1 1 auto;
    position: fixed;
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 38%;
    right: -38%;
    z-index: 98;

    @include breakpoint('s'){
      width: 100%;
      right: -100%;
    }

    background-color: $navigation;

    .links{
        flex: 1 1 auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        ul {
            padding:0;
            margin:0;
            list-style-type: none;
            //min-width: 150px;
            @include breakpoint('s'){
              min-width:auto;
              text-align:center;
            }
            li {
                position: relative;
                padding:0;
                margin:2.5rem 0;
                font-family: 'SourceCodePro';
                text-transform: none;
                font-weight:200;
                font-size: 1.2rem;
                line-height: 1rem;
                @include breakpoint('s'){
                  font-size: 1.5rem;
                  line-height: 1.2rem;
                }
                a {
                    transition: 0.3s;
                    color: $navigation_link;
                    text-decoration: none;

                    &:hover {
                      transition: 0.3s;
                      color:$watermelon;
                    }
                }

            }
        }
    }


   .smlinks {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      @include breakpoint('s'){
        margin: 0 0 7rem 0;
      }

       ul {
           display:block;
           list-style-type: none;
           padding:0;
           li {
               position:relative;
               display:inline-block;
               &:not(:last-child){
                margin-right: 3rem;
               }
           }
       }
   }
}

/* DARKMode */
.darkmode {
  .navigationslide {
    background-color: #999;
  }

  .links{
    ul{
      li{
        a{
          color: $navigation_link_dark;
        }
      }
    }
  }

  .smlinks{
    ul{
      li{
        a{
          svg{
            path{
              fill: $dark;
            }
          }
        }
      }
    }
  }
}
</style>
